// @ts-nocheck
const dateRegex = /^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$/;
const dateRegex2 = /^(0?[1-9]|1[0-2])\/(0?[1-9]|[12]\d|3[01])\/(\d{4})$/;
const dateRegex3 = /^(0?[1-9]|1[0-2])\/(0?[1-9]|[12][0-9]|3[01])\/(\d{2})$/;
const time24HoursRegex = /^([0-1]?[0-9]|2[0-4]):([0-5]?[0-9])$/;
const meridianHoursRegex = /^(0?[1-9]|1[0-2]):([0-5][0-9])(:[0-5][0-9])? ?([APap][Mm])$/;
const compactAMPMTimeRegex = /^(\d{1,2})(\d{2})?([aApP])$/;

export { dateRegex, dateRegex2, dateRegex3, meridianHoursRegex, time24HoursRegex, compactAMPMTimeRegex };